<template>
  <DsPageContent>
    <template v-if="showForm">
      <RetailReportHero
        :title="report.hero.title"
        :eyebrow="report.hero.eyebrow"
        :image="report.hero.image"
        :link="reportLink"
      >
        <template #description>
          <RichText
            :data="report.hero.description"
            class="ds-text-medium ds-color-white ds-padding-top-12"
          />
        </template>
      </RetailReportHero>
      <DsSection
        v-if="report.statsBlock"
        :with-space-bottom="false"
      >
        <DsStatsBlock
          :title="report.statsBlock.title"
          :subtitle="report.statsBlock.subtitle"
          :orientation="report.statsBlock.orientation"
          :items="report.statsBlock.items"
        />
      </DsSection>
      <DsSectionImage
        v-if="report.image"
        theme-variant="light-grey"
        :image="report.image"
        class="ds-padding-y-48 ds-md-padding-y-72"
        :screen="screen"
        is-contained
      />
      <DsSection
        v-if="report.formId"
        id="retail-report-form"
        class="ds-padding-top-48 ds-md-padding-y-72"
        :with-space="false"
        theme="grey"
      >
        <CampaignsFormSection
          :title="report.formTitle"
          :description="report.formDescription"
        >
          <template #form>
            <div class="form-wrapper ds-padding-24 ds-md-padding-48">
              <ContactForm
                :form-id="report.formId"
                :custom-form-labels="campaignFormLabels"
                @success="$emit('form-success')"
              />
            </div>
          </template>
        </CampaignsFormSection>
      </DsSection>
    </template>
    <template v-else>
      <RetailReportHero
        :title="report.thankYouTitle"
        :eyebrow="report.hero.eyebrow"
        :image="report.hero.image"
        :link="report.hero.links[0]"
      >
        <template #description>
          <RichText
            :data="report.thankYouDescription"
            class="ds-text-large ds-color-white ds-padding-top-12"
          />
        </template>
      </RetailReportHero>
    </template>
  </DsPageContent>
</template>

<script setup>
import { DsPageContent, DsSection, DsStatsBlock, DsSectionImage } from 'awds'
import CampaignsFormSection from '../campaigns/campaigns-form-section.vue'
import ContactForm from '../../../core/components/ContactForm.vue'
import RetailReportHero from './retail-report-hero.vue'

defineEmits(['form-success'])

const { labels } = useGlobalData()
const screen = useScreen()
const props = defineProps({
  report: { type: Object, default: null },
  showForm: { type: Boolean, default: true }
})

const ANCHOR_FRAGMENT_URL = '#retail-report-form'

const campaignFormLabels = computed(() => {
  return {
    ...labels.value,
    formSubmitLabelContact: labels.value.formSubmitLabelDownload,
    downloadTitle: labels.value.gatedContentDownloadButton,
    backLinkTitle: labels.value.backLink
  }
})

const reportLink = computed(() => {
  if (props.report && props.report.formId) {
    const ANCHOR_LINK = {
      url: ANCHOR_FRAGMENT_URL,
      title: props.report?.hero?.links[0]?.title,
      openInNewWindow: false,
      nuxt: false
    }
    return ANCHOR_LINK
  }
  return props.report.hero.links[0]
})

useAnchorFragmentSmoothScroll(ANCHOR_FRAGMENT_URL)
</script>
